import { MutationTree } from 'vuex'
import { IAppState } from '@/@types'

const mutations: MutationTree<IAppState> = {
  IS_APP_LOADING_UPDATED: (state, isAppLoading: boolean) => {
    state.isAppLoading = isAppLoading
  },
  SUBSCRIPTION_VIEW_SELECT_UPDATED: (state, subscriptionsViewSelected: string) => {
    state.subscriptionsViewSelected = subscriptionsViewSelected
  },
  IS_COMPONENT_LOADING_UPDATED: (state, isComponentLoading: boolean) => {
    state.isComponentLoading = isComponentLoading
  },
  APP_ERROR_UPDATED: (state, appError: string) => {
    if (state.appErrors.includes(appError)) {
      state.appErrors = state.appErrors.filter(e => e !== appError)
    } else {
      state.appErrors.push(appError)
    }
  },
  APP_NOTIFICATION_UPDATED: (state, notification: string) => {
    if (state.appNotifications.includes(notification)) {
      state.appNotifications = state.appNotifications.filter(n => n !== notification)
    } else {
      state.appNotifications.push(notification)
    }
  },
  APP_SUCCESS_UPDATED: (state, success: string) => {
    if (state.appSuccesses.includes(success)) {
      state.appSuccesses = state.appSuccesses.filter(s => s !== success)
    } else {
      state.appSuccesses.push(success)
    }
  },
  APP_WARNING_UPDATED: (state, warning: string) => {
    if (state.appWarnings.includes(warning)) {
      state.appWarnings = state.appWarnings.filter(s => s !== warning)
    } else {
      state.appWarnings.push(warning)
    }
  },
  IS_EDIT_MODAL_SHOWN_UPDATED: (state, isShown: boolean) => {
    state.isEditModalShown = isShown
  },
  IS_PAYMENT_MODAL_SHOWN_UPDATED: (state, isShown: boolean) => {
    state.isPaymentModalShown = isShown
  },
  IS_PAYMENT_SELECTOR_MODAL_SHOWN_UPDATED: (state, isShown: boolean) => {
    state.isPaymentSelectorModalShown = isShown
  },
  IS_PREMIUM_MONTHLY_PROMO_ACTIVE: (state, isActive: boolean) => {
    state.isPremiumMonthlyPromoActive = isActive
  },
  IS_SIGN_IN_MODAL_SHOWN_UPDATED: (state, isShown: boolean) => {
    state.isSignInModalShown = isShown
  },
  IS_MFA_FORM_SHOWN_UPDATED: (state, isShown: boolean) => {
    state.isMFAFormShown = isShown
  },
  IS_LOADING_CAPTCHA_UPDATED: (state, isLoading: boolean) => {
    state.isLoadingCaptcha = isLoading
  },
  SHOW_GENERIC_BACKGROUND_UPDATED: (state, showGenericBackground: boolean) => {
    state.showGenericBackground = showGenericBackground
  },
  MAINTENANCE_BANNER_CLOSED_FOR_UPDATED: (
    state,
    maintenanceBannerClosedFor: string | number | null
  ) => {
    state.maintenanceBannerClosedFor = maintenanceBannerClosedFor
  },
}

export default mutations
